import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddBanner, IBanner } from "../../Banner.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useEditBanner = (bannerId: string) => {
  const [formData, setFormData] = useState<IAddBanner>({
    image: "",
    link: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [banner, setBanner] = useState<IBanner | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getBanner}/${bannerId}`,
      });
      console.log("response", response);
      setBanner(response);
      populateFormData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (bannerData: IBanner) => {
    setFormData({
      image: bannerData.image,
      link: bannerData.link || "",
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value, files } = e.target as HTMLInputElement;
    if (id === "image" && files && files.length > 0) {
      const file = files[0]; // Get the first selected file
      setFormData((prevState) => ({
        ...prevState,
        image: file, // Store the file in formData
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const handleSubmit: SubmitHandler<IAddBanner> = async () => {
    const formDataToSend = new FormData();

    if (formData.image instanceof File) {
      // Append the file if it's a new image
      formDataToSend.append("image", formData.image);
    } else {
      // Append the existing image URL if the image is a string
      formDataToSend.append("image", formData.image);
    }

    // Append the link if provided (preserves parameters in the URL)
    if (formData.link) {
      formDataToSend.append("link", formData.link);
    }

    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateBanner}/${bannerId}`,
        data: formDataToSend,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response !== "undefined") {
        toast.success("Banner updated successfully", {
          duration: 10000, // Set the duration in milliseconds
        });
        navigate("/banner");
        window.location.reload();
      }
    } catch (error) {
      toast.error("Error updating banner", {
        duration: 10000, // Set the duration in milliseconds
      });
      console.error("Error updating banner:", error);
    }
  };
  const handleCancel = () => {
    window.location.reload();
  };

  return {
    loading,
    formData,
    banner,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useEditBanner;
